import type { ChangeEvent } from 'react';
import styled from 'styled-components';

import { Radio } from '#src/atoms/icons/Radio.tsx';
import type { Color } from '#src/style/types.ts';

const Wrapper = styled.span`
  position: relative;
`;

const HiddenInput = styled.input`
  position: absolute;
  inset: 0;
  width: var(--double-and-a-half-unit);
  margin: 0;
  opacity: 0;
  cursor: pointer;
`;

type Props = {
  checked: boolean;
  width?: number;
  value?: string;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  checkedColor?: Color;
  id?: string;
};

export const SimpleRadio = ({
  checked,
  value,
  width,
  disabled = false,
  onChange = () => {},
  checkedColor,
  onClick,
  id,
}: Props) => {
  return (
    <Wrapper>
      <Radio checked={checked} width={width} fillColor={checkedColor} />
      <HiddenInput
        type="radio"
        value={value}
        id={id}
        disabled={disabled}
        onChange={onChange}
        onClick={onClick}
        checked={checked}
      />
    </Wrapper>
  );
};
